export const PaymentTypes = {
  Online: 1,
  WireTransfer: 2,
};
